// extracted by mini-css-extract-plugin
export var standaloneTable = "_j4-0";
export var standaloneTableWithBodyFill = "_j4-1";
export var withExtraHeader = "_j4-2";